import directives from '../module';

class ComparisonCtrl {
    readonly products   = ['GoAnimate', 'PowToon', 'Google Web Designer'];
    readonly tabs       = this.products.map(p => p.toLowerCase());
    readonly stateTab   = this.$stateParams.product.replace('-vs-animatron', '');
    readonly defaultTab = _.find(this.tabs, p => p.replace(/\s+/g, '') === this.stateTab) || this.tabs[0];

    constructor(private $rootScope: ng.IRootScopeService,
                private $state: ng.ui.IStateService,
                private $stateParams: {product: string}) {
    }

    change(tb: string) {
        const tab = tb.replace(/\s+/g, '');
        const product = `${tab}-vs-animatron`;
        this.$state.transitionTo(`studio-${tab}-landing-comparison`, {product: tab}, {notify: false});
        this.$rootScope.setTitle(product + '.title');
    }
}

directives.component('landingComparisonPage', {
    controller: ComparisonCtrl,
    controllerAs: 'ComparisonCtrl',
    templateUrl: require('landing/comparison.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/landing/LandingComparisonPage.ts